import React from 'react';
import { GoogleLogin } from 'react-google-login';
import { authenticationService } from "../../services";

class GoogleSSO extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null
        }
    }
    componentDidMount() {
        authenticationService.currentUser.subscribe(x => this.setState({ currentUser: x }));
    }

    render() {
        const responseGoogleSuccess = (response) => {
            authenticationService.login(response.profileObj, response.tokenObj);
        }
        const responseGoogleFailure = (response) => {
            console.error(response)
            authenticationService.logout();
        }
        return (<>
                <GoogleLogin
                    clientId={ process.env.REACT_APP_GOOGLE_APP_CLIENT_ID }
                    hostedDomain="instylesolar.com.au"
                    buttonText="Login"
                    onSuccess={responseGoogleSuccess}
                    onFailure={responseGoogleFailure}
                    cookiePolicy={'single_host_origin'}
                />
            </>
        )
    }
}

export default GoogleSSO
